/**
 * Created by Jim on 2018/5/14.
 * Modify by handd on 2018/5/15.
 * Upgrade antd 4 on 2022/9/8.
 */
import axios from "axios";

//const
const EQUIPMENT_CERTIFY_LIST_UPDATE_DATA = "equipmentCertifyList/EQUIPMENT_CERTIFY_LIST_UPDATE_DATA";
const EQUIPMENT_CERTIFY_LIST_STORE_EQUIPMENT_CERTIFIES = "equipmentCertifyList/EQUIPMENT_CERTIFY_LIST_STORE_EQUIPMENT_CERTIFIES";
const EQUIPMENT_CERTIFY_LIST_STORE_SHOW_EQUIPMENT_CERTIFIES = "equipmentCertifyList/EQUIPMENT_CERTIFY_LIST_STORE_SHOW_EQUIPMENT_CERTIFIES";
const EQUIPMENT_CERTIFY_LIST_TOGGLE_MODAL = "equipmentCertifyList/EQUIPMENT_CERTIFY_LIST_TOGGLE_MODAL";
const EQUIPMENT_CERTIFY_LIST_TOGGLE_LOADING = "equipmentCertifyList/EQUIPMENT_CERTIFY_LIST_TOGGLE_LOADING";

const EQUIPMENT_CERTIFY_LIST_MODAL_SUCCESS_TITLE = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_success_title";
const EQUIPMENT_CERTIFY_LIST_MODAL_FAIL_TITLE = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_fail_title";
const EQUIPMENT_CERTIFY_LIST_MODAL_DELETE_SUCCESS_CONTENT = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_deleteSuccess_content";
const EQUIPMENT_CERTIFY_LIST_MODAL_DELETE_FAIL_CONTENT = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_deleteFail_content";
const EQUIPMENT_CERTIFY_LIST_MODAL_OK_LABEL = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_OK_label";
const EQUIPMENT_CERTIFY_LIST_MODAL_CANCEL_LABEL = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyList_modal_cancel_label";

//reducer
export const equipmentCertifyList = (state = {
  loading: false,
  userId: "",
  enterpriseId: "",
  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,
  selectedKey: "",
  certifyStatus: "",
  equipmentCertifies: [],
  showEquipmentCertifies: [],
}, action) => {
  switch (action.type) {
    case EQUIPMENT_CERTIFY_LIST_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_CERTIFY_LIST_STORE_EQUIPMENT_CERTIFIES:
      return {
        ...state,
        equipmentCertifies: action.data,
        showEquipmentCertifies: action.data,
        selectedKey: "",
        certifyStatus: "",
      };
    case EQUIPMENT_CERTIFY_LIST_STORE_SHOW_EQUIPMENT_CERTIFIES:
      return {
        ...state,
        showEquipmentCategories: action.data,
        selectedKey: "",
        certifyStatus: "",
      };
    case EQUIPMENT_CERTIFY_LIST_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case EQUIPMENT_CERTIFY_LIST_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateEquipmentCertifyListData = (data) => {
  return {
    type: EQUIPMENT_CERTIFY_LIST_UPDATE_DATA,
    data: data
  }
};

/**
 * get all equipment certifies
 */
export const getEquipmentCertifies = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  dispatch(updateEquipmentCertifyListData({name: "enterpriseId", value: data.enterpriseId}));
  axios.get(`/api-equipment/getEquipmentCertifyListByEnterpriseId/${data.enterpriseId}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeEquipmentCertifies(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all equipment certifies
 */
export const storeEquipmentCertifies = (equipmentCertifies) => {
  return {
    type: EQUIPMENT_CERTIFY_LIST_STORE_EQUIPMENT_CERTIFIES,
    data: equipmentCertifies
  }
};

/**
 * filter equipment certifies
 */
export const filterEquipmentCertify = (data) => (dispatch) => {
  let showEquipmentCertifies = data.equipmentCertifies.filter(equipmentCertify => {
    return equipmentCertify.name.indexOf(data.name) > -1
  });
  dispatch(storeShowEquipmentCertifies(showEquipmentCertifies));
};

/**
 * store show equipment certifies
 */
export const storeShowEquipmentCertifies = (equipmentCertifies) => {
  return {
    type: EQUIPMENT_CERTIFY_LIST_STORE_SHOW_EQUIPMENT_CERTIFIES,
    data: equipmentCertifies
  }
};

/**
 * delete equipment certify
 */
export const deleteEquipmentCertify = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: `/api-equipment/deleteEquipmentCertify/${data.id}`,
    contentType: "application/json",
    withCredentials: true,
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success delete equipment certify");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: EQUIPMENT_CERTIFY_LIST_MODAL_SUCCESS_TITLE,
          modalContent: EQUIPMENT_CERTIFY_LIST_MODAL_DELETE_SUCCESS_CONTENT,
          modalOk: EQUIPMENT_CERTIFY_LIST_MODAL_OK_LABEL,
          modalCancel: EQUIPMENT_CERTIFY_LIST_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(getEquipmentCertifies({enterpriseId: data.enterpriseId}));
            dispatch(toggleModal({modalVisible: false}))
          },
          onCancel: () => {
            dispatch(getEquipmentCertifies({enterpriseId: data.enterpriseId}));
            dispatch(toggleModal({modalVisible: false}))
          }
        }));
      } else {
        console.error("fail to delete equipment certify");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: EQUIPMENT_CERTIFY_LIST_MODAL_FAIL_TITLE,
          modalContent: EQUIPMENT_CERTIFY_LIST_MODAL_DELETE_FAIL_CONTENT,
          modalOk: EQUIPMENT_CERTIFY_LIST_MODAL_OK_LABEL,
          modalCancel: EQUIPMENT_CERTIFY_LIST_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({modalVisible: false}))
          },
          onCancel: () => {
            dispatch(toggleModal({modalVisible: false}))
          }
        }));
      }
    }
  );
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: EQUIPMENT_CERTIFY_LIST_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_CERTIFY_LIST_TOGGLE_LOADING,
    data: show
  }
};
